import React, { useEffect, useState } from 'react';
import './Features.css';
import { features } from '../../misc/objs';
import { neo4jService } from '../../services/neo4jService';
import { normalizeFreeShippingCard } from '../../config/freeShippingCard';

const Features = () => {
  const [freeShippingCard, setFreeShippingCard] = useState(normalizeFreeShippingCard());

  useEffect(() => {
    let isMounted = true;

    const loadFreeShippingCard = async () => {
      try {
        const settings = await neo4jService.getFreeShippingCard();
        if (isMounted) {
          setFreeShippingCard(normalizeFreeShippingCard(settings));
        }
      } catch (error) {
        if (isMounted) {
          setFreeShippingCard(normalizeFreeShippingCard());
        }
      }
    };

    loadFreeShippingCard();

    return () => {
      isMounted = false;
    };
  }, []);

  const configuredFeatures = features
    .map(feature => {
      if (feature.id !== 1) {
        return feature;
      }

      return {
        ...feature,
        title: freeShippingCard.title,
        description: freeShippingCard.homeDescription,
        color: freeShippingCard.color
      };
    })
    .filter(feature => feature.id !== 1 || (
      freeShippingCard.enabled &&
      (freeShippingCard.title || freeShippingCard.homeDescription)
    ));

  return (
    <div className="features">
      <div className="features-container">
        {configuredFeatures.map((feature) => (
          <div
            key={feature.id}
            className="feature-card"
            style={{ '--feature-color': feature.color }}
          >
            <div className="feature-icon-wrapper">
              <div className="feature-icon">
                {React.cloneElement(feature.icon, {
                  className: 'icon',
                  strokeWidth: 1.5
                })}
              </div>
              <div className="feature-icon-bg" />
            </div>
            <div className="feature-content">
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
